module.exports = __webpack_public_path__ + "img/1oCdDyHeiUZ65TU6RB78H4.c48a1c65.svg";